<script lang="ts">
    import { translation } from "../../stores";
    import { isAlticeStore } from "../../stores/isAlticeStore";

    export let title: string;
</script>
<header class="justify-center m-5 flex-col items-center">
    <img
        width="70"
        height="50"
        src="/img/camera{$isAlticeStore ? '-white' : ''}.png"
        alt="camera"
    />
    <h1 class={$isAlticeStore ? "text-white" : ""}>
         {title}
    </h1>
</header>
